module.exports = __webpack_public_path__ + "static/media/pWidgetImage.c0891b2e.png";